import { useEffect, useState } from 'react';

import type { LegacyRef } from 'react';

import { useGetCompany } from 'Backend/company/getCompany';
import { useGetUser } from 'Backend/users/getUser';
import classes from './LiveChat.module.css';
import ArrowIcon from 'Components/UI_Library/Icons/ArrowIcon';
import { ReactComponent as HumanIcon } from 'Components/UI_Library/Icons/MobileIcons/Human.svg';
import { ReactComponent as KnowledgeIcon } from 'Components/UI_Library/Icons/MobileIcons/Knowledge.svg';

type Props = {
    ref: LegacyRef<HTMLElement> | undefined;
};

declare const window: Window &
    typeof globalThis & {
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        liveagent: any;
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        _laq: any;
    };

const LiveAgent = (props: Props) => {
    const { liveagent } = window;

    const { data: user, isSuccess: usersLoaded } = useGetUser();
    const { data: company, isSuccess: companyLoaded } = useGetCompany();

    const [showChat, setShowChat] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (liveagent && usersLoaded && companyLoaded && !loaded) {
            liveagent.addCustomDetail('Name', `${user.firstName} ${user.lastName}`);
            liveagent.addCustomDetail('Email', user.email);
            liveagent.addCustomDetail('CompanyId', company.id);
            liveagent.addCustomDetail('Company name', company.companyName);
            liveagent.addCustomDetail('Company country', company.country);
            liveagent.addCustomDetail('Company type', company.entityType);

            liveagent.init('https://d.la2-c1cs-ia6.salesforceliveagent.com/chat', '572230000008Q2Z', '00D23000000FFHs');

            if (!window._laq) {
                window._laq = [];
            }
            window._laq.push(() => {
                liveagent.showWhenOnline(
                    '573230000008Qgl',
                    document.getElementById('liveagent_button_online_573230000008Qgl')
                );
            });
            setLoaded(true);
        }
    }, [liveagent, usersLoaded, companyLoaded]);

    useEffect(
        () => () => {
            liveagent.disconnect();
        },
        []
    );

    return (
        <section className={classes.container} ref={props.ref}>
            <div className={classes.options}>
                {showChat ? null : (
                    <a href="https://knowledge.paytron.com/" target="_blank" rel="noreferrer">
                        <div className={classes.icon}>
                            <KnowledgeIcon />
                        </div>
                        Read the Knowledge Base
                    </a>
                )}

                {showChat ? (
                    <div className={classes.chatHeader} onClick={() => setShowChat(false)}>
                        <ArrowIcon size="10px" colour="#457ced" direction="left" />
                        Back to support options
                    </div>
                ) : (
                    <div
                        onClick={() => {
                            liveagent.startChatWithWindow('573230000008Qgl', 'chatchat');
                            setShowChat(true);
                        }}
                        id="liveagent_button_online_573230000008Qgl"
                    >
                        <div className={classes.icon}>
                            <HumanIcon />
                        </div>
                        Speak to a human
                    </div>
                )}
                <iframe
                    name="chatchat"
                    title="chatchat"
                    id="chatchat"
                    style={{ float: 'right', display: showChat ? 'flex' : 'none' }}
                />
            </div>
        </section>
    );
};

export default LiveAgent;
